"use client"

import * as React from "react"
import { useEffect } from "react"

import Image from "next/image"
import Link from "next/link"
import { SiteLogo } from "@/components/Logo"
import { Button, buttonVariants } from "@/components/fun-ui/Button";
import { cn } from "@/lib/utils";
import { useBrowser } from '@/hooks/useBrowser'
import { useTrace } from '@/hooks/useTrace'
import { publicAsset } from "@/lib/public-assets"

export function UnsupportBrowser() {
  const { error: traceError } = useTrace();
  const browser = useBrowser();
  const pkg = process.env.NEXT_PUBLIC_PACKAGE;

  // 记录浏览器不支持事件到监控系统
  useEffect(() => {
    if (pkg !== 'local' && browser) {
      traceError({
        error: {
          message: '记录浏览器不支持事件到监控系统',
        },
        browser: `系统：${browser.getOSName()}@${browser.getOSVersion()};浏览器：${browser.getBrowserName()}@${browser.getBrowserVersion()};引擎：${browser.getEngineName()}userAgent：${window.navigator.userAgent}`,
        page: {
          url: window.location.href,
          type: 'unsupported_browser',
        },
        timestamp: new Date().toISOString(),
      });
    }
  }, [pkg, browser, traceError]);
  const browserList = [{
    name: 'Chrome',
    url: 'https://www.google.cn/intl/zh-CN/chrome/',
  }, {
    name: "Firefox",
    url: "https://www.mozilla.org/zh-CN/firefox/new/",
  }, {
    name: "Edge",
    url: "https://www.microsoft.com/zh-cn/edge",
  }];
  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <div className="h-[72px] flex items-center z-20">
        <Link href="/" className="text-xl flex items-center h-[32px] mx-10">
          <SiteLogo />
        </Link>
      </div>
      <div className="container flex flex-col justify-between h-1/2 space-y-10 translate-y-1/4">
        <div className="flex flex-col justify-center items-center space-y-7">
          <Image priority className="" src={publicAsset("/images/site-unsupport-browser.svg")} width={270} height={170} alt="浏览器暂不支持" />
          <div className="text-center flex flex-col items-center justify-center">
            <div>Findin 暂不支持你的浏览器使用</div>
            <div>使用以下推荐浏览器访问可获得最佳体验</div>
          </div>
        </div>
        <div className="flex space-x-6 md:space-x-11 justify-center items-center">
          {
            browserList.map(({ name, url }) => {
              return (
                <div key={name} className="flex flex-col items-center space-y-7">
                  <Image
                    priority
                    className=""
                    src={publicAsset(`/images/site-browser-${name.toLowerCase()}.svg`)}
                    width={50}
                    height={50}
                    alt={name}
                  />
                  <Link
                    target="_blank"
                    href={url}
                    className={cn(
                      buttonVariants({ variant: "outline", size: "xs" }),
                      "hover:border-transparent text-xs md:text-sm px-2 md:px-4 text-muted-foreground",
                    )}>
                    使用 {name}
                  </Link>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}
